// @ts-check
// ── The address a client is told to email to cancel (browser copy) ────
//
// ⚠️ THIS IS A DELIBERATE SECOND COPY of the rule in
// `netlify/functions/_shared/cancel-address.js`, forced by the module systems:
// that file is CJS inside the functions bundle, this one is an ES module the
// dashboard imports directly. `cancel-address-parity.test.mjs` runs both
// against the same cases and fails the moment they disagree. Change one,
// change the other.
//
// Read the server file's header for WHY the gate is three-part. Short version:
// DKIM verification means the coach may SEND from the domain; it says nothing
// about whether the domain RECEIVES, and an address that cannot receive is
// about to be pasted into a client agreement.

/** The platform-owned address. In signed agreements. Never changes. */
export const PLATFORM_CANCEL_ADDRESS = 'cancel@reply.fitopspro.com';

/**
 * Where this coach's own address receives: `reply.<root>` for a coach who
 * sends from the main domain itself, the sending name for an older mail. one.
 * @param {any} coachSettings
 * @returns {string|null}
 */
export function inboundDomainOf(coachSettings) {
  const cs = coachSettings || {};
  const domain = String(cs.emailDomain || '').trim().toLowerCase();
  if (!domain) return null;
  return domain === String(cs.emailRootDomain || '').trim().toLowerCase() ? `reply.${domain}` : domain;
}

/**
 * @param {any} coachSettings
 * @returns {boolean} true only when the branded address will actually receive
 */
export function isBrandedCancelAddress(coachSettings) {
  const cs = coachSettings || {};
  // The main domain's MX is the coach's own mail, so it receives on reply.<root> (server file's header).
  return cs.emailDomainStatus_ses === 'verified'
    && !!inboundDomainOf(cs)
    && cs.emailInboundStatus_ses === 'live';
}

/**
 * @param {any} coachSettings
 * @returns {string} the coach's own cancel address, or the platform one — never empty
 */
export function buildCancelAddress(coachSettings) {
  if (!isBrandedCancelAddress(coachSettings)) return PLATFORM_CANCEL_ADDRESS;
  return `cancel@${inboundDomainOf(coachSettings)}`;
}
